import type { LegimatieGeslacht } from "../HDN/LegitimatieGeslacht";
import type { InventarisationSelectOption } from "./InventarisationSelectOption";

export const genderOptions: InventarisationSelectOption<LegimatieGeslacht>[] = [
	{ value: "01 M", label: "Man" },
	{ value: "02 V", label: "Vrouw" },
	{ value: "03 X", label: "X" },
];
